import { forwardRef, type Ref, type SVGProps } from "react";
const IconCognitiveProtectionFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M11.811 3c1.046 0 2.09.383 2.895.997.07.05.166.126.264.207.263.217.408.537.407.87l-.035 21.853c0 .295-.113.583-.338.785a2.5 2.5 0 0 1-.378.29c-.804.614-1.77.998-2.895.998-2.493 0-4.504-1.764-4.826-4.065-1.77-.69-2.975-2.378-2.975-4.296 0-.23 0-.536.08-.842C2.804 18.953 2 17.572 2 16.038s.804-2.914 2.01-3.835c-.08-.23-.08-.537-.08-.843 0-1.918 1.287-3.528 3.056-4.295C7.308 4.765 9.318 3 11.811 3m8.377 0c2.493 0 4.503 1.764 4.825 4.065 1.769.767 3.056 2.377 3.056 4.295 0 .306 0 .613-.08.843 1.206.92 2.011 2.301 2.011 3.835s-.805 2.915-2.011 3.759c.08.306.08.612.08.842 0 1.918-1.206 3.605-2.975 4.296-.322 2.3-2.333 4.065-4.826 4.065-1.126 0-2.091-.384-2.895-.998a2.5 2.5 0 0 1-.378-.29 1.05 1.05 0 0 1-.338-.785l-.034-21.529c-.001-.54.217-1.078.67-1.401.804-.614 1.85-.997 2.895-.997m1.417 15.5c-.357-.27-.863-.394-1.249-.16-.385.233-.505.728-.188 1.042.255.253.546.473.864.654a4.32 4.32 0 0 0 3.722.248q.515-.207.952-.534c.359-.269.312-.775-.036-1.058-.348-.282-.866-.226-1.26-.005a2.59 2.59 0 0 1-2.805-.186M7.153 13.025c-.454-.049-.873.265-.833.7.032.35.114.696.243 1.027.225.58.59 1.1 1.064 1.52s1.048.727 1.67.898q.537.147 1.092.154c.457.006.754-.416.668-.844s-.525-.696-.977-.759a2.5 2.5 0 0 1-1.327-.607 2.37 2.37 0 0 1-.734-1.216c-.1-.425-.413-.824-.866-.873"
    />
  </svg>
);
const ForwardRef = forwardRef(IconCognitiveProtectionFilledSVG);
ForwardRef.displayName = "IconCognitiveProtectionFilled";
export { ForwardRef as IconCognitiveProtectionFilled };
